import { render } from "./Color.vue?vue&type=template&id=09a186f2&scoped=true"
import script from "./Color.vue?vue&type=script&lang=js"
export * from "./Color.vue?vue&type=script&lang=js"

import "./Color.vue?vue&type=style&index=0&id=09a186f2&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/minigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a186f2"]])

export default __exports__